export const RouteKeys = {
    root: 0,
    intructionals: 1,
    shop: 2,
    checkout: 2.1,
    gallery: 3
}